<template>
  <div
    class="start-consultation-screen font-sans flex flex-col justify-center items-center px-[16px] pt-[24px] md:p-0 md:mt-[60px]"
  >
    <h1 :class="themeHeadingClasses" class="text-center text-[24px]">Start your consultation</h1>
    <div
      v-if="!this.isRocketRx"
      class="mt-[14px] md:mt-[26px] text-center text-[13px] md:text-[14px] font-normal text-brand-body"
    >
      In {{ stepsCount }} simple steps, your order will be on the way.
    </div>

    <ul
      v-if="this.isRocketRx"
      class="flex flex-col w-full bg-white border border-solid border-[#E0DED8] rounded-2xl mt-[24px] px-[24px] py-[14px] md:py-[26px] md:mt-[36px] md:pl-[36px] md:pr-[48px] md:max-w-[600px]"
    >
      <CoralCircleListItem v-for="(step, index) in steps" :num="index + 1" type="small" :key="index">
        {{ step }}
      </CoralCircleListItem>
    </ul>
    <ul
      v-else
      class="flex flex-col w-full bg-white border border-solid border-brand-border rounded mt-[24px] px-[24px] py-[14px] md:py-[26px] md:mt-[36px] md:pl-[36px] md:pr-[48px] md:max-w-[600px]"
    >
      <BlueCircleListItem v-for="(step, index) in steps" :num="index + 1" type="small" :key="index">
        {{ step }}
      </BlueCircleListItem>
    </ul>

    <button
      v-bind:class="{
        'bg-[#FF5A5B] rounded-2xl mt-[24px] text-[20px] font-semibold': this.isRocketRx,
        'mt-[16px]': !this.isRocketRx,
      }"
      class="continue-btn md:mt-[26px] h-[70px] text-[18px] text-white font-medium w-full md:w-[414px] primary-btn"
      v-on:click="start()"
    >
      <div class="flex justify-center items-center">
        <span v-bind:class="{ 'w-[35%]': this.isRocketRx, 'w-[53%]': !this.isRocketRx }">{{ ctaLabel }}</span>
        <WhiteForwardArrow />
      </div>
    </button>

    <div v-bind:class="{ 'font-semibold': this.isRocketRx }" class="mt-[24px] md:mt-[28px] text-[14px] md:text-[16px]">
      Need help?
      <span>
        <button
          v-bind:class="{ 'text-standard': this.isRocketRx, 'text-blue-link': !this.isRocketRx }"
          class="underline"
          v-on:click="triggerLiveChat()"
        >
          Live chat with us
        </button>
      </span>
    </div>

    <div
      v-bind:class="{ 'text-[#737682] text-[14px]': this.isRocketRx, 'italic text-[13px]': !this.isRocketRx }"
      class="mt-[24px] px-[4px] md:px-0 md:mt-[28px] md:text-[16px] md:w-[414px] text-center"
    >
      *If your treatment isn’t approved by our medical experts, we’ll cancel your order and you won’t be charged.
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import BlueCircleListItem from "@/BookConsultation/components/BlueCircleListItem.vue";
import CoralCircleListItem from "@/BookConsultation/components/CoralCircleListItem.vue";
// disable all rules with !! and use just vue-svg-loader
import WhiteForwardArrow from "!!vue-svg-loader!@legacy-resources-do-not-use/img/icons/white_forward_arrow.svg";

import { Component } from "vue/types/umd";

export default Vue.extend({
  props: {
    start: {
      type: Function as PropType<() => void>,
      required: true,
    },
    triggerLiveChat: {
      type: Function as PropType<() => void>,
      required: true,
    },
    steps: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    stepsCount: {
      type: String as PropType<string>,
      required: true,
    },
    theme: {
      type: String as PropType<string>,
      required: true,
    },
  },
  components: {
    WhiteForwardArrow: WhiteForwardArrow as Component,
    BlueCircleListItem,
    CoralCircleListItem,
  },
  computed: {
    themeHeadingClasses(): string {
      switch (this.theme) {
        case "ziphealth": {
          return "font-bold text-ziphealth-title-blue";
        }
        case "rocketrx": {
          return "text-3xl font-bold text-standard";
        }
        default: {
          return "font-normal md:text-[38px]";
        }
      }
    },
    isRocketRx(): boolean {
      return this.theme === "rocketrx";
    },
    ctaLabel(): string {
      return this.isRocketRx ? "Get started" : "Continue";
    },
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind base;
@tailwind components;
</style>
